import { render } from "./WordCount.vue?vue&type=template&id=022a5d0e&scoped=true"
import script from "./WordCount.vue?vue&type=script&lang=js"
export * from "./WordCount.vue?vue&type=script&lang=js"

import "./WordCount.vue?vue&type=style&index=0&id=022a5d0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-022a5d0e"]])

export default __exports__